import styled from "styled-components";
import { params } from "../../../theme/Params";

export const ScMarkupSpace = styled.div`
  border-radius: ${params.containerBlockRadius};
  box-shadow: ${params.boxShadow};
  overflow: hidden;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  position: relative;

  canvas {
    cursor: default;
    background-color: white !important;
  }

  &.drag {
    canvas {
      cursor: grab;
    }
  }
`;
